import MediaImage from '../components/MediaImage'
import PageHeader from '../components/PageHeader'
import { revealDelay } from '../lib/reveal'
import { pages } from '../data/content'

export default function Press() {
  const { kicker, title, dek, items } = pages.press

  return (
    <main className="py-[clamp(28px,4.5vw,60px)]">
      <PageHeader kicker={kicker} title={title} dek={dek} />

      <div className="mt-12 flex flex-col">
        {items.map((item, index) => (
          <article
            key={item.url}
            data-reveal
            style={revealDelay(index * 0.06)}
            className="group grid grid-cols-1 gap-6 border-b border-rule py-10 first:pt-0 md:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] md:items-start md:gap-x-[clamp(24px,4vw,56px)]"
          >
            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              className="block overflow-hidden bg-sand"
            >
              <MediaImage
                src={item.image}
                size="card"
                alt={item.title}
                className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-in group-hover:scale-[1.02] md:aspect-[16/11]"
              />
            </a>
            <div className="flex flex-col gap-3">
              <div className="text-caps flex flex-wrap items-center gap-3">
                <span className="text-muted">{String(index + 1).padStart(2, '0')}</span>
                {item.outlet ? <span className="text-rose">{item.outlet}</span> : null}
                {item.date ? <span className="text-muted">{item.date}</span> : null}
              </div>
              <h2 className="text-caps-h3 m-0 text-ink">
                <a href={item.url} target="_blank" rel="noreferrer" className="hover:text-rose">
                  {item.title.replace(/&nbsp;/g, ' ')}
                </a>
              </h2>
              {item.excerpt ? (
                <p className="m-0 max-w-[52ch] leading-relaxed text-copy">{item.excerpt}</p>
              ) : null}
              <a
                href={item.url}
                target="_blank"
                rel="noreferrer"
                className="text-caps mt-1 self-start border-b border-ink pb-[3px] hover:border-rose hover:text-rose"
              >
                Read the piece
              </a>
            </div>
          </article>
        ))}
      </div>
    </main>
  )
}
